import axios from '../axios'
import i18n from '../i18n'
import configurations from '../configurations'

const defaultData = {
  channel: 'aplikasi',
  date: new Date().toISOString(),
  description: '',
  complainant: {
    email: '',
    full_name: '',
    ic_num: '',
    phone: ''
  },
  status: 'new',
  subject: '',
  type: 'feedback',
  user: ''
}

const feedback = {
  namespaced: true,
  state: {
    data: defaultData,
    error: null,
    id: '',
    iterator: {
      rowsPerPageItems: [
        5,
        10,
        25,
        { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
      ]
    },
    list: [],
    loading: false,
    rules: {
      full_name: 'required',
      ic_no: 'required|min:14',
      description: 'required',
      email_address: 'required|email',
      phone: 'required',
      subject: 'required'
    }
  },
  getters: {
    isLoading: function (state, getters, rootState, rootGetters) {
      return state.loading
    }
  },
  actions: {
    fetchData: async function (context, payload = defaultData) {
      context.commit('setLoading', { loading: true })
      try {
        const response = await axios.post(`/query`, { url: btoa(`/complaint/${payload.id}`) })
        response.data.attachmentUrl = configurations.WORKER + '/getAttachments/complaint'
        context.commit('setData', { data: response.data })
        context.commit('setError', { error: null })
      } catch (error) {
        context.commit('setError', { error })
        this.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: i18n.t('fetching_data_failed'),
          visible: true
        })
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    fetchList: async function (context, payload = defaultData) {
      context.commit('setLoading', { loading: true })
      try {
        const apiUrl = `/complaint/_design/query/_view/query?startkey=["feedback","${
          context.rootState.auth.session.name
        }",{}]&endkey=["feedback","${
          context.rootState.auth.session.name
        }"]&descending=true&include_docs=true`

        let response = await axios.post(`/query`, { url: btoa(apiUrl) })
        context.commit('setList', {
          list: response.data.rows.length > 0 ? response.data.rows.map(row => row.doc) : []
        })
        context.commit('setError', { error: null })
        return response.data
      } catch (error) {
        context.commit('setError', { error })
        this.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: i18n.t('fetching_data_failed'),
          visible: true
        })
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    patchComplainant: async function (context, payload = {}) {
      const data = Object.assign({}, context.state.data.complainant, payload)
      context.commit('setComplainant', { data })
    },
    patchData: async function (context, payload = {}) {
      const data = Object.assign({}, context.state.data, payload)
      if (payload.file) {
        data.file = payload.file
      }
      if (payload.geolocation) {
        data.geolocation = payload.geolocation
      }
      context.commit('setData', { data })
    },
    resetData: async function (context, payload = {}) {
      context.commit('setData', { data: defaultData })
      context.commit('setId', { id: '' })
      context.commit('setError', { error: null })
      context.commit('setLoading', { loading: false })
    },
    submitData: async function (context, rootState, payload = defaultData) {
      const data = Object.assign({}, context.state.data)
      data.council = 'mpt'
      const apiUrl = '/complaint/_design/backend/_update/feedback'
      context.commit('setLoading', { loading: true })
      data.user = data.complainant.email

      try {
        let response = await axios.post(`/query`, { url: btoa(apiUrl), payload: data })
        return response.data
      } catch (error) {
        context.commit('setError', { error })
        this.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: i18n.t('submit_failed'),
          visible: true
        })
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    }
  },
  mutations: {
    setError: function (state, payload = { error: null }) {
      state.error = payload.error
    },
    setId: function (state, payload = { id: '' }) {
      state.id = payload.id
    },
    setLoading: function (state, payload = { loading: false }) {
      state.loading = payload.loading
    },
    setComplainant: function (state, payload = { data: defaultData }) {
      state.data.complainant = payload.data
    },
    setData: function (state, payload = { data: defaultData }) {
      state.data = payload.data
    },
    setList: function (state, payload = { list: [] }) {
      state.list = payload.list
    }
  }
}

export default feedback
